import { FieldValues } from '../../types';

export const buildFilesArray = (currentFiles?: FieldValues['files'], newFiles?: FileList | null): File[] => {
  const currentFileNames = (currentFiles || []).map((item) => item.name);
  return [
    ...(currentFiles || []),
    ...Array.prototype.slice.call(newFiles || []).filter((item: File) => !currentFileNames.includes(item.name)),
  ];
};
